<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="协议名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入协议名称" />
      </a-form-model-item>
      <a-form-model-item label="协议编码" prop="code" >
        <a-input v-model="form.code" placeholder="请输入协议编码" :disabled="formType === 2 || (form.id !== null && form.id !== undefined)" />
      </a-form-model-item>
      <a-form-model-item label="用户类型" prop="type" >
        <a-select v-model="form.type" placeholder="请选择用户类型">
          <a-select-option :value="0">用户端</a-select-option>
          <a-select-option :value="1">师傅端</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="协议内容" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入备注" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addAgreement, getAgreement, updateAgreement } from '@/api/agreement/agreement'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  components: {
    Editor
  },
  props: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        name: null,
        code: null,
        type: null,
        content: '',
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '协议名称不能为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '协议编码不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '用户类型不能为空', trigger: 'change' }
        ],
        content: [
          { required: true, message: '协议内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        code: null,
        type: null,
        content: '',
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加协议信息'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAgreement({ id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改协议信息'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAgreement(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.reset()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAgreement(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.reset()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

